import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { Utils } from '../../Utils/Utils';
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';
import { StatusMessage, StatusMessageModel, StatusMessageType } from '../../Widgets/StatusMessage'

var FILTER_DELIM = '-delim-';
const batchSize = 100;

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlGetList: string;
    urlDetail: string;
    urlCount: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}
class FreeRoundBrowseRequest {
    public OfferId: string;
    public CampaignId: string;
    public CustomerId: string;
    public RemoteId: string;
    public CustomerOperationId: string;
    public PlayerRemoteId: string;
    public PlayerName: string;
    public PlayerId: string;
    public CurrencyId: string;
    public CampaignName: string;
    public CampaignRemoteId: string;
    public WinPayMethods: string;
    public WinFrom: string;
    public WinTo: string;
    public RoundsAssignedFrom: string;
    public RoundsAssignedTo: string;
    public RoundsPlayedFrom: string;
    public RoundsPlayedTo: string;
    public PendingSpinsFrom: string;
    public PendingSpinsTo: string;
    public ValidFrom: string;
    public ValidTo: string;
    public Result: string;
    public Status: string;
    public Source: string;
    public LastOfferId: number | null;
    public BatchSize: number;
}

export class IndexPage extends PageBase<IndexPageOptions> {
    private _runButton: JQuery;
    private _loadMoreButton: JQuery;
    private _resetFilterButton: JQuery;
    private _currentRequest: FreeRoundBrowseRequest;

    private _filterPlayerName: JQuery;
    private _filterRemoteId: JQuery;
    private _filterStatus: MultiSelectApi;
    private _filterSource: JQuery;
    private _btnCountResult: JQuery;
    private _totalEntries: JQuery;
    private _checkAll: JQuery;
    private _processing: JQuery;
    private _statusMessage: JQuery;

    constructor(options: IndexPageOptions) {
        super(options);

        this.run = this.run.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.getCountResult = this.getCountResult.bind(this);
        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
        this.enableRunButton = this.enableRunButton.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this._options = options;
    }

    init(): void {
        this._filterPlayerName = Utils.getJQueryById('filterPlayerName');
        this._filterRemoteId = Utils.getJQueryById('filterRemoteId');
        this._filterStatus = new MultiSelectApi('filterStatus');
        this._filterSource = Utils.getJQueryById("filterSource");

        this._runButton = Utils.getJQueryById("btnRunQuery");
        this._runButton.on("click", this.run);
        this._loadMoreButton = Utils.getJQueryById("btnLoadMore");
        this._loadMoreButton.on("click", this.loadMore);
        this._resetFilterButton = Utils.getJQueryById("btnResetFilter");
        this._resetFilterButton.on("click", this.resetFilter);
        this._btnCountResult = Utils.getJQueryById("btnCountResult");
        this._btnCountResult.on("click", this.getCountResult);
        this._totalEntries = Utils.getJQueryById("totalEntries");
        this._checkAll = Utils.getJQueryById("selectAll");
        this._checkAll.on("change", this.checkBoxAll);
        this._processing = Utils.getJQueryById("processing");
        this._statusMessage = Utils.getJQueryById("statusMessageWrapper");

    }

    private run(): void {
        this.disableRunButton();
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        totalEntries.innerText = "##";
        this._currentRequest = this.getBrowseRequest();
        let table = this.getTableBody();
        table.innerHTML = "";
        this.sendRequest(this._currentRequest);
    }

    private loadMore(): void {
        this.sendRequest(this._currentRequest);
    }

    private showLoadMoreButton(): void {
        this._loadMoreButton.removeClass("display-none");
    }

    private hideLoadMoreButton(): void {
        this._loadMoreButton.addClass("display-none");
    }

    private disableRunButton(): void {
        this._runButton.attr("disabled", 1);
    }

    private enableRunButton(): void {
        this._runButton.removeAttr("disabled");
    }

    private resetFilter(): void {
        this._filterPlayerName.val('');
        this._filterRemoteId.val('');
        this._filterStatus.selectAll();
        this._filterSource.val('Live');
    }

    private getCountResult() {
        let request = Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
        let urlCount = this._options.urlCount;
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        let processing = this._processing;
        let statusMessage = this._statusMessage
        let displayMessage = this.displayMessage;
        processing.show();
        $.ajax({
            url: urlCount,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                totalEntries.innerText = data;
                processing.hide();
                statusMessage.hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                displayMessage(jqXHR);
            }
        });
    }

    private sendRequest(request: FreeRoundBrowseRequest) {
        let urlGetList = this._options.urlGetList;
        let table = this.getTableBody();
        let showLoadMore = this.showLoadMoreButton;
        let hideLoadMore = this.hideLoadMoreButton;
        let enableRunButton = this.enableRunButton;
        let processing = this._processing;
        let statusMessage = this._statusMessage
        let displayMessage = this.displayMessage;
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];

        let getDetailUrl = this._options.urlDetail;
        processing.show();
        $.ajax({
            url: urlGetList,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                let parsedData = JSON.parse(data);
                let items = parsedData.Items;
                let totalCount = parsedData.FilteredCount;
                if (items.length < batchSize + 1) {
                    hideLoadMore();
                }
                else {
                    request.LastOfferId = items[batchSize].Id;
                    showLoadMore();
                }
                const enabled = ['Completed', 'Canceled'];
                $.each(items, function (index, item) {
                    if (index < batchSize) {
                        let row = table.insertRow(-1);
                        let cell0 = row.insertCell(0);
                        cell0.innerHTML = `<b><a href='${getDetailUrl}/${item.Id}' id=${item.Name}"></b>${item.Name}</a>`;
                        let cell1 = row.insertCell(1);
                        cell1.innerHTML = `${item.RemoteId}`;
                        let cell2 = row.insertCell(2);
                        cell2.innerHTML = `${item.ValidFrom}`;
                        let cell3 = row.insertCell(3);
                        cell3.innerHTML = `${item.ValidTo}`;
                        let cell4 = row.insertCell(4);
                        cell4.innerHTML = `${item.RoundsAssigned}`;
                        let cell5 = row.insertCell(5);
                        let css = enabled.indexOf(item.Status) > -1 ? "status-enabled" : "status-disabled";
                        cell5.innerHTML = `<span class="${css}">${item.Status}</span>`;
                    }
                });

                totalEntries.innerText = totalCount;

                processing.hide();
                enableRunButton();
                statusMessage.hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                enableRunButton();
                displayMessage(jqXHR);
            }
        });
    }

    private displayMessage(jqXHR: JQueryXHR): void {
        var statusMessageWrapper = Utils.getJQueryById("statusMessageWrapper");
        let statusMessageData = <StatusMessageModel>{
            code: "500",
            autoClose: false,
            class: "danger",
            message: "Unexpected error",
            type: StatusMessageType.Error
        };
        var statusMessage = new StatusMessage(statusMessageData);
        statusMessageWrapper.html(statusMessage.getHTMLmessage());
        StatusMessageHelper.initValidator();
        StatusMessageHelper.initSatusMessage();
        statusMessageWrapper.show();
    }

    private getTableBody(): HTMLTableSectionElement {
        return document.getElementById("tableFreeRoundCampaign").getElementsByTagName("tbody")[0];
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedOffer']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._checkAll[0]).checked;
        }
    }

    private getBrowseRequest(): FreeRoundBrowseRequest {
        let request = new FreeRoundBrowseRequest();
        request.PlayerName = this._filterPlayerName.val();
        request.RemoteId = this._filterRemoteId.val();
        request.Status = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
        request.Source = this._filterSource.val();
        request.BatchSize = batchSize + 1;
        return request;
    }
}



/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FreeRoundCampaigns/IndexPage.ts
 **/